/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{position:absolute;background-color:#fff;border:1px solid #ccc;display:flex;flex-direction:column;z-index:10001}[_nghost-%COMP%]     timepicker table{margin:auto}[_nghost-%COMP%]   .buttons[_ngcontent-%COMP%]{padding:10px}"];
export { styles as styles };
